import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import { ClinicalAgreementGate } from "./ClinicalAgreementGate";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
      <Loader2 className="w-8 h-8 text-sky-600 animate-spin" />
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (user.clinical_agreement_required) return <ClinicalAgreementGate />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/app" replace />;
  if (user.clinical_agreement_required) return <ClinicalAgreementGate />;
  return children;
}
